import { Component, HostBinding, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-color-cell-renderer',
  template: `<div class="cell"><div class="cell-content" [style.background-color]="color"></div></div>`,
  styles: [
    '.cell {height: 100%;width: 100%;display: flex;align-items: center;justify-items: center;}',
    '.cell-content {width: 14px;height: 20px;border-radius: 10px;flex-grow:0}',
  ]
})
export class ColorCellRendererComponent implements ICellRendererAngularComp {

  @HostBinding('style.background') backgroundColor = 'black';

  public color;

  refresh(params: any): boolean {
    this.color = params.value
    return true;
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    //throw new Error('Method not implemented.');
  }


  agInit(params: ICellRendererParams): void {
    this.color = params.value;
  }

  ngOnDestroy() {
  }

}
